/*
 * HomePage
 */

import React from 'react';

// Material Resources

// Others
import { Switch, Route, useRouteMatch } from 'react-router-dom';

// Components & Others
import NotFound from '../../NotFoundPage';
import AccountTypeList from '../../../components/Models/AccountType/AccountTypeList';
import AccountTypeEdit from '../../../components/Models/AccountType/AccountTypeCreateEdit/edit';
import AccountTypeForm from '../../../components/Models/AccountType/AccountTypeForm';

function AccountTypePage() {
  const { path } = useRouteMatch();

  return (
    <Switch>
      <Route exact path={path} component={AccountTypeList} />
      <Route path={`${path}/crear`} component={AccountTypeForm} />
      <Route path={`${path}/:id`} component={AccountTypeEdit} />
      <Route path="" component={NotFound} />
    </Switch>
  );
}

export default AccountTypePage;
